import type { Pace } from '../core/types.js';

export interface PaceProfile {
  successGrowth: number;
  stretchGrowth: number;
  nearMissGrowth: number;
  earlySlipGrowth: number;
  maxStepUp: number;
  maxStepDown: number;
  nearMissThreshold: number;
}

export const PACE_PROFILES: Record<Pace, PaceProfile> = {
  gentle: {
    successGrowth: 1.05, stretchGrowth: 1.08, nearMissGrowth: 1.0, earlySlipGrowth: 0.96,
    maxStepUp: 1.10, maxStepDown: 0.92, nearMissThreshold: 0.80,
  },
  steady: {
    successGrowth: 1.08, stretchGrowth: 1.12, nearMissGrowth: 1.0, earlySlipGrowth: 0.92,
    maxStepUp: 1.15, maxStepDown: 0.88, nearMissThreshold: 0.85,
  },
  ambitious: {
    successGrowth: 1.12, stretchGrowth: 1.18, nearMissGrowth: 0.99, earlySlipGrowth: 0.88,
    maxStepUp: 1.20, maxStepDown: 0.84, nearMissThreshold: 0.90,
  },
};
